import React, { useContext } from "react";
import { Box, Heading, ResponsiveContext } from "grommet";
import img from "../../../images/news/info-image.png";
import { isMobileTabletResponsive } from "../../../utils/utils";
import { CardWithLinkAndStatus } from "../../Cards/vertical/CardWithLinkAndStatus";
export var EventsSection = function EventsSection() {
  var size = useContext(ResponsiveContext);
  var isMobileWidth = isMobileTabletResponsive(size);
  return /*#__PURE__*/ React.createElement(
    React.Fragment,
    null,
    /*#__PURE__*/ React.createElement(
      Heading,
      {
        level: 2,
        margin: {
          bottom: "3rem",
        },
      },
      "\u0412\u0430\u0448\u0438 \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u044F"
    ),
    /*#__PURE__*/ React.createElement(
      Box,
      {
        flex: true,
        direction: isMobileWidth ? "column" : "row",
        align: isMobileWidth ? "center" : "",
        style: {
          flexWrap: "wrap",
          rowGap: "2rem",
          columnGap: "4rem",
        },
      },
      /*#__PURE__*/ React.createElement(CardWithLinkAndStatus, {
        paragraph: "Статус",
        subtext: "Москва, Военный полигон Алабино",
        heading: "Гонка Героев",
        image: img,
        link: "Внести изменения",
      }),
      /*#__PURE__*/ React.createElement(CardWithLinkAndStatus, {
        paragraph: "Статус",
        subtext: "Москва, Военный полигон Алабино",
        heading: "Гонка Героев",
        image: img,
        link: "Внести изменения",
      }),
      /*#__PURE__*/ React.createElement(CardWithLinkAndStatus, {
        paragraph: "Статус",
        subtext: "Москва, Военный полигон Алабино",
        heading: "Гонка Героев",
        image: img,
        link: "Внести изменения",
      }),
      /*#__PURE__*/ React.createElement(CardWithLinkAndStatus, {
        paragraph: "Статус",
        subtext: "Москва, Военный полигон Алабино",
        heading: "Гонка Героев",
        image: img,
        link: "Внести изменения",
      })
    )
  );
};
